import { ISubmissionModules } from '@framework/frontoffice-submission';
import { generatePath, LoaderSpin, useHistory } from '@framework/ui';
import { getPrincipalModule } from './getPrincipalModule';

export interface ISubmissionPrincipalModuleRedirectorProps {
  submissionId: string | null | undefined;
  submissionModules: ISubmissionModules;
}

export function SubmissionPrincipalModuleRedirector(
  props: ISubmissionPrincipalModuleRedirectorProps,
) {
  const { submissionModules, submissionId } = props;

  const history = useHistory();

  // Fase di caricamento
  if (submissionModules.isLoading) {
    return <LoaderSpin full />;
  }

  // Ricavo il modulo principale
  const principalModule = getPrincipalModule(submissionModules.modules);

  if (principalModule) {
    history.push(
      generatePath('/richieste/:id/moduli/:moduleId', {
        id: submissionId!,
        moduleId: principalModule.id!,
      }),
    );
    return;
  }

  // Come fallback, redirect alla pagina di guida alla compilazione
  history.push(generatePath('/richieste/:id', { id: submissionId! }));

  return null;
}
